import React, { type ReactElement } from 'react';

export const MoveIconSmall = (): ReactElement => (
  <>
    <svg
      width="100"
      height="86"
      viewBox="0 0 100 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3841_14477)">
        <path
          d="M16.2148 68.2158H50.7148"
          stroke="#031D44"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M16.2148 73.7641L36.1434 73.9775"
          stroke="#031D44"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M82.928 57.1191H10.8566C7.49944 57.1191 4.78516 59.8222 4.78516 63.1654V79.099C4.78516 82.4422 7.49944 85.1452 10.8566 85.1452H82.928C86.2852 85.1452 88.9994 82.4422 88.9994 79.099V63.0942C88.9994 59.8222 86.2852 57.1191 82.928 57.1191Z"
          stroke="#031D44"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M86.3582 55.1275L7.42966 60.5335C4.14395 60.7469 1.2868 58.2573 1.07252 54.9852L0.00109041 37.0599C-0.213195 33.7878 2.28681 30.9425 5.57252 30.7291L84.5011 25.3231C87.7868 25.1097 90.6439 27.5993 90.8582 30.8714L91.9297 48.7967C92.2154 52.1399 89.7154 54.9141 86.3582 55.1275Z"
          fill="#EAF0FA"
        />
        <path
          d="M93.7857 0.853577L88.5714 4.41019C88.5714 4.41019 79 1.06697 74.7143 1.20924C68.5714 1.42263 41 8.39359 41 8.39359C41 8.39359 42 12.0925 46.2857 11.5234C48.2143 11.2389 57.4286 9.17604 57.4286 9.17604C57.4286 9.17604 42.9286 18.1387 42 18.5655C42.6429 19.4902 45.2143 21.4108 48.9286 18.9923C51.1429 17.4985 65.2857 9.17604 65.2857 9.17604L59.4286 14.5821L54.7143 32.1517C56.0714 32.3651 57.9286 31.3693 58.4286 29.9466C58.9286 28.524 62.6429 18.6366 62.6429 18.6366C62.6429 18.6366 70.9286 14.1553 74.2143 13.7285C77.5 13.3017 79.3571 19.0634 79.2143 21.2685C79.0714 23.4736 76.7143 26.1055 73 30.8002C62 33.8589 65.3571 39.0516 65.3571 39.0516L74.8571 36.2063C74.8571 36.2063 85.5714 27.9549 89.7143 26.5323C93.8571 25.1097 97.5 20.4149 97.5 20.4149L99.2857 20.1304"
          stroke="#031D44"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M64.4269 2.91638L47.8555 3.6277C47.8555 3.6277 48.6412 6.33073 51.3555 5.8328"
          stroke="#031D44"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.9297 42.1814L48.3583 40.1185"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M14.2852 47.9431L34.1423 46.9473"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3841_14477">
          <rect width="100" height="85.7143" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </>
);
